import Axios from "axios";
import {
    SET_USERS_LIST,
    UNSET_USERS_LIST
  } from "@/store/mutation-types";
import { saveUpdateUserSetup, getUsersList, deleteUser, updateUserPassword, saveUserRolePermission, getUserPermission } from "@/store/api";
// initial state
const state = {
  getUsersList: [],
};

const getters = {
  getUsersList(state) {
    return state.getUsersList;
  },
};
const mutations = {
  [SET_USERS_LIST](state, data) {
    state.getUsersList = data;
  },
  [UNSET_USERS_LIST](state) {
    state.getUsersList = [];
  },

};

const actions = {
  
  saveUpdateUserSetup({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateUserSetup, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getUsersList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getUsersList, data)
        .then(function (response) {
          // exclude super admin or user with id 1 from the list
          let users = response.data.data || [];
          users = users.filter(u => u.id !== 1 && u.tag !== "superAdmin");
          commit('SET_USERS_LIST', users);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_USERS_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  updateUserPassword({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.put(updateUserPassword, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  deleteUser({ state, commit }, data) {
    commit("SET_LOADING", {color: "warning"});
    return new Promise(function (resolve, reject) {
    Axios.post(deleteUser, {id:data})
        .then((response) => {
            resolve(response);  
        })
        .catch((error) => {
            reject(error)  
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },


  saveUserRolePermission({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUserRolePermission, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getUserPermission({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getUserPermission, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
